import * as React from "react";
const SvgFiRrTelescope = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-telescope_svg__a)">
      <path
        fill="#062147"
        d="m23.905 9.074-4-8.5a1.001 1.001 0 0 0-1.81.852l.362.769-13.188 5.62a3.755 3.755 0 0 0-2.194 4.181L.598 13.083a1 1 0 0 0 .803 1.832l2.579-1.132c.373.408.836.731 1.364.944.453.183.928.274 1.4.274.5 0 1-.102 1.473-.305l3.322-1.415-4.441 9.287a1.001 1.001 0 0 0 1.805.863l4.598-9.614 4.598 9.614a1 1 0 0 0 1.334.47c.498-.238.709-.836.47-1.334L14.8 11.892l6.85-2.919.449.951a1 1 0 1 0 1.809-.852zM7.43 12.858a1.73 1.73 0 0 1-1.34.015 1.73 1.73 0 0 1-.954-.939 1.747 1.747 0 0 1 .917-2.279l13.255-5.648 1.486 3.158L7.43 12.86z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-telescope_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTelescope;
